import React from "react";
import { useTranslation } from "react-i18next";
import { ErrorPage } from "components/errors/ErrorPage";

interface IErrorFallbackProps {
  error: Error;
}

export const ErrorFallback: React.FC<IErrorFallbackProps> = ({ error }) => {
  const { t } = useTranslation(["error"]);

  return (
    <ErrorPage
      title={t("error:fallback.title")}
      message={t("error:fallback.message")}
      error={error as Error}
      onRetry={() => window.location.reload()}
    />
  );
};
